import { PropsWithChildren } from 'react';
import { Layout } from 'antd';

import Header from './components/Header';
import Footer from './components/Footer';

import styles from './mainlayout.module.css';
import AuthenticatedGuard from '../modules/auth/components/AuthenticatedGuard';
import { Outlet } from 'react-router-dom';

type MainLayoutProps = PropsWithChildren<{ 
  noMenu?: boolean 
}>;

const MainLayout = ({ children, noMenu } : MainLayoutProps) => (
  <AuthenticatedGuard>
    <Layout className={styles.app}>
      <Layout>
        <Header className="fixedContainer" noMenu={noMenu}/>
        <Layout.Content className={`${styles.content} fixedContainer`}>
          {children}
          <Outlet />
        </Layout.Content>
        <Footer/>
      </Layout>
    </Layout>
  </AuthenticatedGuard>
);

export default MainLayout;